import React from 'react';
export function EmployeeActivityRowHeader(_ref) {
  let {
    claim
  } = _ref;
  const ReportSubheader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", {
      className: "border-start",
      style: {
        minWidth: '50pt',
        maxWidth: '50pt'
      }
    }, "R&D%"), /*#__PURE__*/React.createElement("th", {
      className: "border-end",
      style: {
        minWidth: '50pt',
        maxWidth: '50pt'
      }
    }, "Months"));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, claim.claim_group.project_methodology === 'project_basis' ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null), claim.claim_group.claim_project_reports.map((report, index) => {
    return /*#__PURE__*/React.createElement("th", {
      key: index,
      colSpan: "2",
      className: "bg-primary text-white border-left border-end"
    }, report.project_name || 'Unnamed Project');
  }), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null)) : null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, "Name"), /*#__PURE__*/React.createElement("th", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, "Number"), claim.claim_group.project_methodology === 'project_basis' ? claim.claim_group.claim_project_reports.map((_, index) => {
    return /*#__PURE__*/React.createElement(ReportSubheader, {
      key: index
    });
  }) : null, /*#__PURE__*/React.createElement("th", {
    style: {
      minWidth: '70pt',
      maxWidth: '70pt'
    }
  }, "R&D %"), /*#__PURE__*/React.createElement("th", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, "Total Salary"), /*#__PURE__*/React.createElement("th", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, "R&D Amount")));
}